/* eslint-disable no-shadow,consistent-return,no-param-reassign,no-console,max-len,no-unused-vars */
import jApiHubin from '@/services/jApiHubin';
import router from '@/router';

const state = {
};

const mutations = {
};

const actions = {
  // Mitra ----------------------------------------------------------------------
  async createMitra({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiHubin.createMitra(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateMitra({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiHubin.updateMitra(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteMitra({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiHubin.deleteMitra(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async exportMitra({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiHubin.exportMitra(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Pengumuman ----------------------------------------------------------------------
  async getListPengumuman({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiHubin.getListPengumumanWidget(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async createPengumuman({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiHubin.createPengumuman(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updatePengumuman({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiHubin.updatePengumuman(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deletePengumuman({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiHubin.deletePengumuman(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async exportPengumuman({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiHubin.exportPengumuman(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Buku Tamu ----------------------------------------------------------------------
  async createBukuTamu({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiHubin.createBukuTamu(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateBukuTamu({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiHubin.updateBukuTamu(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreHubin.js